import React from 'react';
import HeroSection from '../components/HeroSection';
import PositioningSection from '../components/PositioningSection';
import ProductShowcase from '../components/ProductShowcase';
import TractionSection from '../components/TractionSection';
import SpacesSection from '../components/SpacesSection';
import BluechipEcosystem from '../components/BluechipEcosystem';
import SocialPrimitives from '../components/SocialPrimitives';
import ArchitectureSection from '../components/ArchitectureSection';
import TeamSection from '../components/TeamSection';
import RoadmapOption4 from '../components/RoadmapOption4';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <ProductShowcase />
      <TractionSection />
      <PositioningSection />
      <SocialPrimitives />
      <ArchitectureSection />
      <RoadmapOption4 />
      <BluechipEcosystem />
      <TeamSection />
      <SpacesSection />
      <Footer />
    </div>
  );
};

export default Home;
